import * as Yup from 'yup';

const upsertNamescanSettingsSchema = Yup.object().shape({
  namescan_api_key: Yup.string(),
  namescan_method: Yup.string().oneOf(['emerald', 'sapphire']),
});

export default upsertNamescanSettingsSchema;
